import { StyleSheet } from 'react-native';
import { ticketColors, ticketFonts } from '../theme/public-api';

/** Tipografía semántica ticket — usar en lugar de fontFamily locales. */
export const ticketText = StyleSheet.create({
  kicker: {
    fontSize: 11,
    fontWeight: '700',
    letterSpacing: 0.88,
    textTransform: 'uppercase',
    color: ticketColors.ink3,
    fontFamily: ticketFonts.sans,
  },
  kickerGold: {
    fontSize: 11,
    fontWeight: '700',
    letterSpacing: 0.88,
    textTransform: 'uppercase',
    color: ticketColors.gold,
    fontFamily: ticketFonts.sans,
  },
  title: {
    fontSize: 15,
    fontWeight: '600',
    color: ticketColors.ink,
    fontFamily: ticketFonts.sans,
  },
  subtitle: {
    fontSize: 13,
    fontWeight: '500',
    color: ticketColors.ink2,
    fontFamily: ticketFonts.sans,
  },
  body: {
    fontSize: 14,
    fontWeight: '500',
    color: ticketColors.ink,
    fontFamily: ticketFonts.sans,
  },
  bodyStrong: {
    fontSize: 14,
    fontWeight: '600',
    color: ticketColors.ink,
    fontFamily: ticketFonts.sans,
  },
  meta: {
    fontSize: 12,
    fontWeight: '500',
    color: ticketColors.ink2,
    fontFamily: ticketFonts.sans,
  },
  metaMuted: {
    fontSize: 12,
    fontWeight: '500',
    color: ticketColors.ink3,
    fontFamily: ticketFonts.sans,
  },
  caption: {
    fontSize: 11,
    fontWeight: '500',
    color: ticketColors.ink3,
    fontFamily: ticketFonts.sans,
  },
  mono: {
    fontFamily: ticketFonts.mono,
    fontVariant: ['tabular-nums'],
  },
  price: {
    fontSize: 22,
    fontWeight: '700',
    color: ticketColors.ink,
    fontFamily: ticketFonts.mono,
    fontVariant: ['tabular-nums'],
    letterSpacing: -0.4,
  },
  statusOk: {
    fontSize: 10,
    fontWeight: '600',
    letterSpacing: 0.5,
    textTransform: 'uppercase',
    color: ticketColors.ok,
    fontFamily: ticketFonts.sans,
  },
  statusBad: {
    fontSize: 10,
    fontWeight: '600',
    letterSpacing: 0.5,
    textTransform: 'uppercase',
    color: ticketColors.bad,
    fontFamily: ticketFonts.sans,
  },
  statusWarn: {
    fontSize: 10,
    fontWeight: '600',
    letterSpacing: 0.5,
    textTransform: 'uppercase',
    color: ticketColors.warn,
    fontFamily: ticketFonts.sans,
  },
  statusMuted: {
    fontSize: 10,
    fontWeight: '600',
    letterSpacing: 0.5,
    textTransform: 'uppercase',
    color: ticketColors.ink3,
    fontFamily: ticketFonts.sans,
  },
});
